import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["searchString", "createDateFilter", "lastActivityFilter", "sort"];
import { defineMutation } from 'pulse/mutations';
import { useMutation } from 'pulse/react';
import { createPortalsFetchClient } from 'portals-platform-lib';
import { useCallback } from 'react';
import { generateDateFilter, sortFieldsToStrings } from '../constants/filters';
import { SUPPORT_PORTAL_EXPORT_BASE_PATH, TICKET_EXPORT_CSV_PATH } from '../../api/paths';
const portalExportFetch = createPortalsFetchClient(SUPPORT_PORTAL_EXPORT_BASE_PATH);
const exportCsv = async _ref => {
  var _res$headers$get;
  let {
      searchString,
      createDateFilter,
      lastActivityFilter,
      sort
    } = _ref,
    variables = _objectWithoutPropertiesLoose(_ref, _excluded);
  const res = await portalExportFetch(TICKET_EXPORT_CSV_PATH, {
    method: 'POST',
    body: JSON.stringify({
      params: Object.assign({
        searchString: searchString === '' ? undefined : searchString,
        sort: sortFieldsToStrings(sort),
        dateFilters: [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(Boolean)
      }, variables)
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) {
    throw new Error(`Export CSV error: ${res.status} - ${res.statusText}`);
  }
  const txt = await res.text();
  const filenameRegex = /filename="([^"]+)"/;
  const filenameMatch = (_res$headers$get = res.headers.get('Content-Disposition')) === null || _res$headers$get === void 0 ? void 0 : _res$headers$get.match(filenameRegex);
  const name = filenameMatch ? filenameMatch[1] : null;
  if (!name) {
    throw new Error('Export CSV error: No filename found');
  }
  const blob = new Blob([txt], {
    type: 'text/csv'
  });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl.toString();
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
  /* TODO Error Message or Success Message with Toast (not native in HubSpot so need Joe's advice) */
};
const ExportCsv = defineMutation({
  typeName: 'customerPortalApp:ExportCsv',
  mutation: exportCsv
});
export const useCsvExport = variables => {
  const [mutate, {
    loading,
    error
  }] = useMutation(ExportCsv);
  const doExport = useCallback(() => {
    mutate(variables).catch(() => {});
  }, [mutate, variables]);
  return {
    doExport,
    loading,
    error
  };
};